import { RouterModule, Routes } from '@angular/router';



const routes:Routes = [

  { path: '', redirectTo: '/admin/main', pathMatch: 'full' },
  { path: '**', redirectTo: '/admin/main', pathMatch: 'full' },
  // { path: 'extra', loadChildren: './extra-pages/extra-pages.module#ExtraPagesModule' },

];



export const AppRoutingModule = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/app-routing.module.ts